module.exports = __webpack_public_path__ + "img/feature_buy_en.78ba053c.png";